module.exports = __webpack_public_path__ + "static/media/img1.d31427a3.jpg";